export const normalizeOption = (option, valueKey = 'value', labelKey = 'label') => {
    // Handle primitive types (string, number)
    if (typeof option === 'string' || typeof option === 'number') {
        return { value: option, label: String(option) };
    }
    
    // Handle objects with custom or standard keys
    const value = option[valueKey] !== undefined ? option[valueKey] : option.value;
    const label = option[labelKey] !== undefined ? option[labelKey] : (option.label || String(value));
    
    return {
        value,
        label: String(label),
        disabled: option.disabled || false,
        ...option,
    };
};

